import React, { useEffect } from 'react'
import { Route, Routes, BrowserRouter } from 'react-router-dom'
import NavbarComponent from '../components/global/navbar'
import URL from '../constants/urls'
import Main from '../pages/main'
import PropTypes from 'prop-types'
import { toast, ToastContainer } from 'react-toastify'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { getPartnerDetailsBySLug, globalKeyStore } from '../redux/actions/globalState'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../constants/globalConstants'
import NotFound from '../redux/not-found/error-404'
// import Login from '../components/loginCom/Login'
import { isNetworkAvailable } from '../utils/helper'
// isPermissionExist
import Footer from '../components/loginCom/footer'
import Booking from '../pages/booking/Booking'
import Forgotpassword from '../pages/Forgotpassword'
import UserProfile from '../pages/Profile/UserProfile'
import Loader from '../components/global/Loader'
import Success from '../pages/booking/Success'
import PaymentFails from '../pages/booking/PaymentFails'
import useNetwork from '../services/NetworkDetector'
import Resetpassword from '../pages/Forgotpassword/Resetpassword'
import Navigating from '../components/MasqueradeUserLogin'
import DraggableButton from '../components/global/DraggableButton'
import { getConfigDetails } from '../services/config'



function RoutesComponent({ dispatch, isFetching, isOpened, partnerDetails, favIcon }) {
	const user = window.location.toString().split('/')[3]
	const changeFacilityonPage = window.location.toString().split('/')
	const isOnline = useNetwork()
	const isMasquerade = localStorage.getItem('masquerade')

	window.addEventListener('click', function () { dispatch(globalKeyStore({ isOpened: false })) })

	useEffect(() => {
		if (user) {
			let slug = user
			if (user != 'navigating') {
				slug = user
			} else {
				slug = changeFacilityonPage[changeFacilityonPage?.length - 1]
			}
			// if (facility && facility != 'signup' && facility != 'login' && !facility?.includes('=')) {
			//     slug = `${slug}/${facility}`
			// }
			localStorage.removeItem('partnerData')
			localStorage.removeItem('client_id')
			const facilityID = window.location?.toString()?.split('/')?.[4]
			dispatch(getPartnerDetailsBySLug(slug)).then((res) => {
				if (res?.data?.email) {
					// console.log(res?.data?.brand_setting, 'res?.data?.brand_setting')
					// setTitle(res?.data?.company_name ? res?.data?.company_name : res?.data?.name)
					// setFaviconPath(res?.data?.brand_setting ? res?.data?.brand_setting?.logourl : res?.data?.partner_details?.brand_setting?.logourl)
					localStorage.removeItem('partnerData')
					dispatch(globalKeyStore({ logoImage: res?.data?.brand_setting?.logourl, favIcon: res?.data?.brand_setting?.faviconurl }))
					if (res?.data?.customer_portal_permission && Object.keys(res?.data?.customer_portal_permission)?.length > 0) {
						// setPartnerDetails(res?.data)
						// const perData = sortPortalPermissionByKey(res?.data, 'Access Permissions')
						// if (!isPermissionExist(perData, 'Is Receipt Login Access') && !isPermissionExist(perData, 'Is Receipt Signup Access')) {
						// 	localStorage.removeItem('sign_in')
						// 	localStorage.removeItem('sign_up')
						// 	localStorage.setItem('isLoggedIn', false)
						// }
					}

					localStorage.setItem('partnerData', JSON.stringify(res?.data))
					localStorage.setItem('client_id', JSON.stringify(res?.data?.clients))
					if (changeFacilityonPage.length < 5 && changeFacilityonPage[4] !== '') {
						const URL_FacId = window.location?.toString()?.split('/')?.[5]
						const facilityIdfromURL = (facilityID == 'event' && !isNaN(URL_FacId)) ? URL_FacId : !isNaN(facilityID) ? facilityID : res?.data?.facilities?.[0]?.id ? JSON.stringify(res?.data?.facilities?.[0]?.id) : ''
						localStorage.setItem('selectedFacilityId', facilityIdfromURL)
						// localStorage.setItem('selectedFacilityId', JSON.stringify(res?.data?.facilities?.[0]?.id))
					}
					const partnerData = res?.data
					let color = partnerData?.brand_setting ? partnerData?.brand_setting?.color : partnerData?.partner_details?.brand_setting?.color
					let rgb = partnerData?.brand_setting ? JSON.parse(partnerData?.brand_setting?.rgb_color) : JSON.parse(partnerData?.partner_details?.brand_setting?.rgb_color)
					if (color) {
						document.documentElement.style.setProperty('--bs-primary', color)
						document.documentElement.style.setProperty('base-color', color)
						document.documentElement.style.setProperty('primary', color)
						document.documentElement.style.setProperty('textcolor', color)
						document.documentElement.style.setProperty('--bs-btn-bg', color)
						document.documentElement.style.setProperty('--bs-primary-rgb', `${rgb?.r},${rgb?.g},${rgb?.b}`)
						document.documentElement.style.setProperty('--bs-list-group-active-border-color', color)
						document.documentElement.style.setProperty('--bs-list-group-active-color', color)
						document.documentElement.style.setProperty('--bs-list-group-active-bg', color)
					}
				} else {
					console.log('error')
				}
			}).catch(() => {
				console.log('error')
			})
		}
	}, [EMPTY_ARRAY])


	function capitalize(s) {
		return s && s[0].toUpperCase() + s.slice(1)
	}

	useEffect(() => {
		if (favIcon) {
			const updateFavicon = () => {
				const favicon = document.querySelector('link[rel="icon"]')
				const appletouchicon = document.querySelector('link[rel="apple-touch-icon"]')
				favicon.href = favIcon
				appletouchicon.href = favIcon
			}
			updateFavicon()
		}

		const updateTitle = () => {
			if (user == 'worldport-la') {
				document.title = capitalize('breeze') + ' Event Parking'
			} else {
				document.title = capitalize(user) + ' Event Parking'
			}
		}

		updateTitle()
	}, [user, favIcon])

	const notify = (type, message) => {
		if (type === 'error') {
			toast.error(message, { position: toast.POSITION.TOP_RIGHT })
			toast.clearWaitingQueue()
		} else if (type === 'success') {
			toast.success(message, { position: toast.POSITION.TOP_RIGHT })
			toast.clearWaitingQueue()
		}
	}

	const handleStopMasquerading = () => {
		localStorage.removeItem('masquerade')
		if (window.location.host.includes('localhost')) {
			window.location.href = 'https://localhost:8888/admin/user-management'
		} else {
			window.location.href = `${getConfigDetails().adminUrl}/admin/user-management`
		}
	}

	return (
		<BrowserRouter forceRefresh className="mt-3">
			{isFetching ? <div className='d-flex align-content-center flex-wrap vh-100 justify-content-center'><Loader /></div> :
				<div>
					<NavbarComponent isOpened={isOpened} notify={notify} />
					{isNetworkAvailable() && isOnline ? <>
						{partnerDetails?.customer_portal_permission && Object.keys(partnerDetails?.customer_portal_permission)?.length > 0 ?
							<Routes>
								<Route
									path={URL?.HOME}
									element={<Main notify={notify} />}
								// element={(sortPortalPermissionByKey(partnerDetails, 'Main Menu') && sortPortalPermissionByKey(partnerDetails, 'Main Menu')?.length > 0) && isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Access Permissions'), 'Login Access') ? <Main /> : isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Access Permissions'), 'Login Access') ? <Login notify={notify} /> : (!sortPortalPermissionByKey(partnerDetails, 'Main Menu')) && !isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Access Permissions'), 'Login Access') ? <NotFound /> : <NotFound />}
								/>
								<Route
									path={URL?.FACILITYHOME}
									element={<Main notify={notify} />}
								// element={(sortPortalPermissionByKey(partnerDetails, 'Main Menu') && sortPortalPermissionByKey(partnerDetails, 'Main Menu')?.length > 0) && isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Access Permissions'), 'Login Access') ? <Main /> : isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Access Permissions'), 'Login Access') ? <Login notify={notify} /> : (!sortPortalPermissionByKey(partnerDetails, 'Main Menu')) && !isPermissionExist(sortPortalPermissionByKey(partnerDetails, 'Access Permissions'), 'Login Access') ? <NotFound /> : <NotFound />}
								/>
								{/* <Route path={URL?.BOOKING_PAGE1} element={<Booking notify={notify} />} /> */}
								<Route path={URL?.BOOKING_DETAIL1} element={<Booking notify={notify} />} />
								<Route path={URL?.FACILITY_BOOKING_DETAIL1} element={<Booking notify={notify} />} />
								<Route path={URL?.PAYMENT_SUCCESS} element={<Success notify={notify} partnerDetails={partnerDetails} />} />
								<Route path={URL?.FACILITY_PAYMENT_SUCCESS} element={<Success notify={notify} partnerDetails={partnerDetails} />} />
								<Route path={URL.PROFILE} element={<UserProfile notify={notify} />} />
								<Route path={URL?.FORGOT_PASSWORD} element={<Forgotpassword notify={notify} />} />
								<Route path={URL?.FACILITY_FORGOT_PASSWORD} element={<Forgotpassword notify={notify} />} />
								<Route path={URL.PAYMENT_FAIL} element={<PaymentFails notify={notify} />} />
								<Route path={URL.FACILITY_PAYMENT_FAIL} element={<PaymentFails notify={notify} />} />
								<Route path={URL.RESET_PASSWORD} element={<Resetpassword notify={notify} />} />
								<Route path={URL.NAVIGATING_MASQUERADE_PARTNER} element={<Navigating />} />
								<Route path={URL.NAVIGATING_PARTNER} element={<Navigating />} />
							</Routes> : <Routes>
								<Route path='*' element={<NotFound />} />
							</Routes>}</> : <h3 className='py-5 my-3 text-center'>No internet</h3>}
					<Footer />
					<ToastContainer limit={1} />
				</div>}
			{isMasquerade && <DraggableButton
				handleStopMasquerade={handleStopMasquerading}
			/>}
		</BrowserRouter>
	)
}
RoutesComponent.propTypes = {
	dispatch: PropTypes.func,
	isFetching: PropTypes.bool,
	isOpened: PropTypes.bool,
	partnerDetails: PropTypes.object,
	favIcon: PropTypes.object
}

RoutesComponent.defaulProps = {
	dispatch: noop,
	isFetching: false,
	isOpened: false,
	partnerDetails: EMPTY_OBJECT,
	favIcon: EMPTY_OBJECT
}

function mapStateToProps({ globalReducers }) {
	return {
		isFetching: globalReducers?.loader,
		isOpened: globalReducers?.isOpened,
		partnerDetails: globalReducers?.partnerDetails,
		favIcon: globalReducers.favIcon
	}
}
export default connect(mapStateToProps)(RoutesComponent)
